module.exports = __webpack_public_path__ + "static/img/2-2.6354a082.png";